import { useState } from "react";
import { ticker, hotTopics } from "@/mocks/portal";

export default function TopicWall() {
  const [visible, setVisible] = useState(8);

  return (
    <section className="border-y border-background-200 bg-background-100">
      {/* 滚动快讯 */}
      <div className="mx-auto flex max-w-[1200px] items-center gap-3 overflow-hidden px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
          <i className="ri-pulse-line text-[13px]" aria-hidden="true" />
          实况
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-[ticker_28s_linear_infinite] gap-8">
            {ticker.concat(ticker).map((t, i) => (
              <span key={i} className="flex shrink-0 items-center gap-2 whitespace-nowrap text-[13px] text-foreground-600">
                <b className="font-semibold text-primary-600">[{t.tag}]</b>
                {t.text}
                <i className="ri-arrow-right-line ml-2 text-primary-300" aria-hidden="true" />
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 话题 / 标签墙 */}
      <div className="mx-auto max-w-[1200px] px-4 pb-8 md:px-6 md:pb-10">
        <div className="flex items-end justify-between gap-4 border-t border-background-200 pt-5">
          <div>
            <h2 className="text-lg font-bold text-foreground-950 md:text-xl">正在热议的话题墙</h2>
            <p className="mt-1 text-xs text-foreground-500 md:text-sm">
              大家在讨论的换线、延迟与可用性话题，点标签即对应一段切换指南角度。
            </p>
          </div>
          <span className="font-num shrink-0 text-xs text-foreground-500">{visible}/{hotTopics.length} 个话题</span>
        </div>

        <div className="mt-4 flex flex-wrap gap-2.5">
          {hotTopics.slice(0, visible).map((t) => (
            <a
              key={t.label}
              href="#guide"
              className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3.5 py-2 text-[13px] text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <i className="ri-price-tag-3-line text-[13px] text-secondary-500 transition-colors group-hover:text-primary-600" aria-hidden="true" />
              {t.label}
              <span className="font-num text-[11px] text-accent-600">{t.heat}</span>
            </a>
          ))}
          {visible < hotTopics.length && (
            <button
              type="button"
              onClick={() => setVisible((v) => Math.min(v + 4, hotTopics.length))}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-dashed border-background-300 px-3.5 py-2 text-[13px] text-primary-600 transition-colors hover:border-primary-400"
            >
              <i className="ri-add-line text-sm" aria-hidden="true" />
              展开更多
            </button>
          )}
        </div>
      </div>

      <style>{`@keyframes ticker { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </section>
  );
}